import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Step 41/42 — Global fetch wrapper.
// Sends the httpOnly session cookie on every fetch (so brand-new signups
// authenticate against THEIR account, not the legacy test agent), and
// bounces 401 responses back to /login so an expired session lands the
// user at sign-in cleanly. Auth-page calls go through XHR
// (`auth/apiClient.js`) so they're unaffected.
const _origFetch = window.fetch.bind(window);
window.fetch = async (input, init = {}) => {
  const next = { ...init, credentials: init.credentials ?? 'include' };
  const res = await _origFetch(input, next);
  try {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (
      res.status === 401 &&
      !url.includes('/api/auth/') &&
      !window.location.pathname.startsWith('/login') &&
      !window.location.pathname.startsWith('/signup') &&
      !window.location.pathname.startsWith('/forgot-password') &&
      !window.location.pathname.startsWith('/reset-password') &&
      !window.location.pathname.startsWith('/verify-email')
    ) {
      const nextPath = window.location.pathname + window.location.search;
      window.location.href = '/login?next=' + encodeURIComponent(nextPath);
    }
  } catch { /* noop */ }
  return res;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
